"use strict";

var _classCallCheck = require("/home/runner/work/jaeger/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/jaeger/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/runner/work/jaeger/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/jaeger/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/runner/work/jaeger/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _HtmlLayer = _interopRequireDefault(require("./HtmlLayer"));

var _MeasurableNodesLayer = _interopRequireDefault(require("./MeasurableNodesLayer"));

var _NodesLayer = _interopRequireDefault(require("./NodesLayer"));

var _types = require("./types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
} // Copyright (c) 2019 Uber Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.


var HtmlLayersGroup =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(HtmlLayersGroup, _React$PureComponent);

  function HtmlLayersGroup() {
    _classCallCheck(this, HtmlLayersGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(HtmlLayersGroup).apply(this, arguments));
  }

  _createClass(HtmlLayersGroup, [{
    key: "renderLayers",
    value: function renderLayers() {
      var _this$props = this.props,
          getClassName = _this$props.getClassName,
          layers = _this$props.layers,
          graphState = _this$props.graphState,
          setSizeVertices = _this$props.setSizeVertices;
      return layers.map(function (layer) {
        var key = layer.key,
            setOnContainer = layer.setOnContainer;

        if (layer.measurable) {
          var renderNode = layer.renderNode,
              setOnNode = layer.setOnNode;
          return React.createElement(_MeasurableNodesLayer.default, {
            key: key,
            getClassName: getClassName,
            graphState: graphState,
            layerType: _types.ELayerType.Html,
            renderNode: renderNode,
            senderKey: key,
            setOnContainer: setOnContainer,
            setOnNode: setOnNode,
            setSizeVertices: setSizeVertices
          });
        }

        if (layer.renderNode) {
          var _renderNode = layer.renderNode,
              _setOnNode = layer.setOnNode;
          return React.createElement(_NodesLayer.default, {
            key: key,
            getClassName: getClassName,
            graphState: graphState,
            layerType: _types.ELayerType.Html,
            renderNode: _renderNode,
            setOnContainer: setOnContainer,
            setOnNode: _setOnNode
          });
        } // html edges layer


        throw new Error('Not implemented');
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_HtmlLayer.default, Object.assign({
        topLayer: true,
        classNamePart: "HtmlLayersGroup"
      }, this.props), this.renderLayers());
    }
  }]);

  return HtmlLayersGroup;
}(React.PureComponent);

exports.default = HtmlLayersGroup;